module.exports = __webpack_public_path__ + "img/dai3.4a8044eb.png";